import React from "react";
import "./Error.css";
import { Link } from "react-router-dom";

function ErrorPage() {
  return (
    <div className="errorpage">
      <h2>We are sorry, Page not found!</h2>
      <h3>
        The page you are looking for might have been removed, had its name
        changed, or is temporarily unavailable.
      </h3>
      <Link className="btn btn-primary" to={"/"}>
        Back to Home page
      </Link>
    </div>
  );
}

export default ErrorPage;
